@if (!sucheMitBildungszielen) {
  <div
    aria-label="Suchleiste"
    role="region"
    class=""
    [ngClass]="{ 'now-decorative-card now-decorative-card-small mb-4': isDesktop$ | async }"
  >
    <div class="d-flex justify-content-center align-items-center mb-3">
      <div [ngClass]="{ 'w-100': isMobile$ | async }">
        <div class="mb-3 bildungsbereichauswahl">
          <now-wbsuche-lib-bildungsbereichauswahl></now-wbsuche-lib-bildungsbereichauswahl>
        </div>
        <div class="d-flex">
          <now-wbsuche-lib-textsuche
            class="d-block min-width"
            (dataChange)="dataChange.emit()"
            [inputElementId]="textSucheInputElementId"
          ></now-wbsuche-lib-textsuche>
          <div
            class="search-btn"
            [ngClass]="{ 'w-100': isPhone$ | async, 'ms-3': (isPhone$ | async) === false }"
          >
            <button
              id="search-button"
              class="now-btn now-btn-primary"
              [ngClass]="{ 'now-btn-loading': angeboteLoading$ | async }"
              (click)="dataChange.emit()"
            >
              Suchen
            </button>
          </div>
        </div>
        @if (
          (this.berufeService.isBerufssuche$ | async) ||
          (this.referrerService.berufeRef$ | async) !== null
        ) {
          <div class="now-info-box-warning alert mt-3 w-100" role="alert">
            <div class="now-info-box-body">
              @if (context$ | async; as context) {
                <div class="now-info-box-message">
                  <p>
                    {{ context.helpText }}
                  </p>
                  @if (context.url) {
                    <a class="now-icon now-icon-arrow-right-before" href="{{ context.url }}">{{
                      context.linkText
                    }}</a>
                  }
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}
